import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Contract } from '../../../class/contract';
import { ContractService } from '../../../service/contract/contract.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../../interfaces/marker';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { Router, ActivatedRoute } from '@angular/router';

import { calendarES } from '../../../../../theme/functions/calendarES';
import { formatDate } from '../../../../../theme/functions/formatDate.function';

@Component({
  selector: 'app-new-contract',
  templateUrl: './new-contract.component.html',
  styleUrls: ['./new-contract.component.scss']
})
export class NewContractComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Contract;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public save_exit: boolean;

    private id: number;
    public showPage: number;

    public es: any;

    public customer_guide_id: number;
    public company_id: number;

    public myEmployeeId: string;

    constructor(
        public fb: FormBuilder,
        public contractService: ContractService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader,
        public router: Router,
        private route: ActivatedRoute,
        public hasPermissionService: HasPermissionService,
    ) {
        this.save_exit = false;

        this.es = calendarES();
    }

    ngOnInit() {
        this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
        this.id = +this.route.snapshot.paramMap.get('contract_id');
        
        if (this.id !== 0 && (this.id !== undefined)) {
            var promiseLoc = this.contractService.infoContract(this.id).toPromise().then(
                response =>{
                this.edit = response.json();
                this.createForm(this.edit);
                this.showPage = 1;
                },
                error=>{
                this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
                this.router.navigateByUrl('/pages/digital-documentation/contracts');
                // this.showPage = 1;
                }
            );
        } else {
            this.createForm();
            this.showPage = 1;
        }
    }

    createForm(data:any = null) {
        data = data || {
            id: undefined,
            candidate_id: null,
            company_id: null,
            venue_id: null,
            profile_survey_id: null,
            start_contract: null,
        };
      
        this.form = this.fb.group({
            id: new FormControl(data.id),
            candidate_id: new FormControl( data.candidate_id, Validators.compose([ Validators.required ]) ),
            company_id: new FormControl( data.company_id, Validators.compose([ Validators.required ]) ),
            venue_id: new FormControl( data.venue_id, Validators.compose([ Validators.required, Validators.minLength(1) ])),
            profile_survey_id: new FormControl( data.profile_survey_id, Validators.compose([ Validators.required ]) ),
            start_contract: new FormControl(data.start_contract ? new Date(data.start_contract) : null, Validators.compose([ Validators.required ]) ),
        });
    }

    public cancelContract () {
        this.form.reset();
        this.close.emit(true);
        this.router.navigateByUrl('/pages/digital-documentation/contracts');
    }

    public saveContract(values){
        this.save_exit = true;
        this.newContract(values);
    }

    public newContract(values: any) {
        values.candidate_id = values.candidate_id.id ? values.candidate_id.id : values.candidate_id;
        values.customer_guide_id = values.company_id.customer_guide ? values.company_id.customer_guide.id : values.customer_guide_id;
        values.company_id = values.company_id.id ? values.company_id.id : values.company_id;
        values.profile_survey_id = values.profile_survey_id.id ? values.profile_survey_id.id : values.profile_survey_id;
        values.start_contract = (values.start_contract) ? formatDate(values.start_contract) : null;

        values.activated = '1';
        // values.end_contract = '';

        values.business_id = '2';   // ID = 2 para notificar que son contrataciones de Synergo
        

        values.created_by_id = this.myEmployeeId;


        /* const companies = [];
        values.companies.forEach(element => {
            companies.push(element.value);
        }); */

        if (values && this.form.valid) {
            const promise = (this.edit) ? this.contractService.updateContract(this.edit.id, values) : this.contractService.newSynergoContract(values);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                            this.router.navigateByUrl('/pages/digital-documentation/contracts');
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public selectedCompany(values) {
        if (values.customer_guide) {
          this.customer_guide_id = values.customer_guide.id;
          this.company_id = values.id;
        }
    }

    /* public gotoProfileSurvey(values) {
        let token = localStorage.getItem('token');
        let profile_survey_id = (values.profile_survey_id.id) ? values.profile_survey_id.id : values.profile_survey_id;
        
        window.open('/pages/selection/profile-surveis/' + profile_survey_id + '?token=' + token );
    } */


}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/contracts/new-contract/new-contract.component.ts